import React from 'react';
import './App.css';
import SortingVisualizer from './SortingVisualizer/SortingVisualizer'

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <SortingVisualizer/>
      </header>
    </div>
  );
}

export default App;
